// extracted by mini-css-extract-plugin
export var details = "_dm-0";
export var inspectorPopover = "_dm-1";